module.exports = __webpack_public_path__ + "img/BOONTERM.9392289.png";